import { htmlSanitizer } from "@/services/utilities/html-sanitizer";

/**
 * ST143-TI-17771 (§3): `v-safe-html` — drop-in replacement for `v-html` that runs the value through
 * htmlSanitizer before assigning it to innerHTML. Sanitizes on BOTH `mounted` and `updated` — a directive that
 * only sanitizes on mount is a classic hole, since Vue re-triggers `v-html`-like assignment on every value
 * change.
 *
 * Usage: `v-safe-html="content"` (defaults to the "richText" profile) or
 * `v-safe-html="{ value: content, profile: 'mail' }"` for the mail profile.
 */
export const safeHtml = {
  mounted(el, binding) {
    applySafeHtml(el, binding);
  },
  updated(el, binding) {
    applySafeHtml(el, binding);
  },
};

function applySafeHtml(el, binding) {
  const raw = binding.value;
  const isObjectForm = raw && typeof raw === "object" && "value" in raw;
  const value = isObjectForm ? raw.value : raw;
  const profile = isObjectForm && raw.profile ? raw.profile : htmlSanitizer.RICH_TEXT_PROFILE;

  el.innerHTML = htmlSanitizer.sanitize(value, profile);
}
